import { Link } from 'react-router';
import { CLAIM_SUBMISSION_ROUTES } from '@fixtyer/content';

const linkStyle = 'font-medium text-white underline decoration-brand-400 underline-offset-4 hover:decoration-white';

export function CouncilClaimIntro({ area }: { area: 'Dudley' | 'Bristol' | 'West Northamptonshire' }) {
  const route = CLAIM_SUBMISSION_ROUTES.find((entry) => entry.areaLabel === area);
  if (!route) throw new Error(`Missing official claim route for ${area}`);

  return (
    <div className="mb-10 max-w-3xl">
      <p className="text-xl leading-relaxed text-brand-100">
        Claiming for pothole damage in {area}? Check the road authority, gather your evidence
        and use the official council process below. You can submit directly yourself.
      </p>
      <a href={route.officialUrl} className="mt-6 inline-flex rounded-lg bg-white px-5 py-3 font-semibold text-brand-950 hover:bg-brand-100">
        Official {area} claim instructions
      </a>
      <ol className="mt-6 space-y-4 list-decimal pl-5 text-brand-100">
        <li><strong className="text-white">Check the road authority.</strong> {route.scopeNote}</li>
        <li>
          <strong className="text-white">Prepare your evidence.</strong> Keep the exact location, date and time,
          photographs taken safely, damage details and repair invoices or quotes. Preserve any earlier report references.
        </li>
        <li><strong className="text-white">Use the council claim process.</strong> {route.submissionNote}</li>
      </ol>
      <p className="mt-3 text-sm text-brand-200">
        Reporting a pothole for repair is separate from claiming compensation. Official claim route checked 7 September 2026.
      </p>
      <nav aria-label={`${area} claim preparation guides`} className="mt-6">
        <ul className="flex flex-wrap gap-x-6 gap-y-3 text-sm">
          <li><Link className={linkStyle} to="/guides/pothole-claim-letter-template">Free claim letter template</Link></li>
          <li><Link className={linkStyle} to="/guides/request-road-inspection-records">Request inspection records</Link></li>
          <li><Link className={linkStyle} to="/blog/council-rejected-your-pothole-claim">Help with a rejected claim</Link></li>
        </ul>
      </nav>
      <p className="mt-6 text-sm text-brand-200">
        Fixtyer&apos;s optional £35 pack helps organise your documents; you review and submit them yourself.
        Compensation is not guaranteed. The road-maintenance data below provides background, not proof of liability for your incident.
      </p>
    </div>
  );
}
